const filterMixins = {
    props: {
        index: {
            type: [Number, String],
            default: -1,
        },
        filter: {
            type: Object,
        },
        eventBus: {
            type: Object,
        },
        adapter: {
            type: Object,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        autoFocus: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        this.eventBus.$on(`focus-filter-${this.filter.filter.path}`, this.delayedFocus);
    },
    methods: {
        delayedFocus() {
            setTimeout(() => this.focusFilter(), 100);
        },
        focusFilter() {
            // to be implemented by each filter as needed
        },
        makePayload() {
            // returns filter value payload
            throw new Error(`Please implement that method`);
        },
    },
};

export default filterMixins;
